import { BsModalService } from 'ngx-bootstrap/modal';
import * as i0 from "@angular/core";
import * as i1 from "ngx-bootstrap/modal";
export class ModalService {
    constructor(modalService) {
        this.modalService = modalService;
        this.config = {
            backdrop: false,
            ignoreBackdropClick: false
        };
    }
    openModal(component, options) {
        const config = Object.assign({}, this.config, options);
        this.modalRef = this.modalService.show(component, config);
    }
    closeModal() {
        if (this.modalRef !== undefined) {
            this.modalRef.hide();
        }
    }
}
ModalService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ModalService_Factory() { return new ModalService(i0.ɵɵinject(i1.BsModalService)); }, token: ModalService, providedIn: "root" });
